export const ACTION_DIRECTION = Object.freeze({
  BUY: { id: 0, value: '_ASK' }, // TODO: Correct? BUY is _ASK
  SELL: { id: 1, value: '_BID' }
});

export const OPTION_LEG_ACTION = Object.freeze({
  BUY_TO_OPEN: { name: 'buyToOpen', fullname: 'Buy to Open', shortname: 'BTO', direction: ACTION_DIRECTION.BUY },
  BUY_TO_CLOSE: { name: 'buyToClose', fullname: 'Buy to Close', shortname: 'BTC', direction: ACTION_DIRECTION.BUY },
  SELL_TO_OPEN_COVERED: {
    name: 'sellToOpenCovered',
    fullname: 'Sell to Open Covered',
    shortname: 'STO',
    direction: ACTION_DIRECTION.SELL
  },
  SELL_TO_OPEN_UNCOVERED: {
    name: 'sellToOpenUncovered',
    fullname: 'Sell to Open Uncovered',
    shortname: 'STO',
    direction: ACTION_DIRECTION.SELL
  },
  SELL_TO_OPEN: {
    name: 'sellToOpenCovered',
    fullname: 'Sell to Open Covered',
    shortname: 'STO',
    direction: ACTION_DIRECTION.SELL
  },
  SELL_TO_CLOSE: {
    name: 'sellToClose',
    fullname: 'Sell to Close',
    shortname: 'STC',
    direction: ACTION_DIRECTION.SELL
  }
});

export const STOCK_LEG_ACTION = Object.freeze({
  BUY: { name: 'buy', fullname: 'Buy', shortname: 'B', direction: ACTION_DIRECTION.BUY },
  SELL: { name: 'sell', fullname: 'Sell', shortname: 'S', direction: ACTION_DIRECTION.SELL }
});

export const STRATEGY_LONG_SHORT = Object.freeze({
  LONG: { id: 0 },
  SHORT: { id: 1 }
});

export const STRATEGY_BULL_BEAR = Object.freeze({
  BULL: { id: 0 },
  BEAR: { id: 1 }
});

export const ASSET_CLASS = Object.freeze({
  STOCK: { id: 0 },
  OPTION: { id: 1 }
});

export function getLegAction(actionID) {
  switch (actionID) {
    case 'BTO':
      return OPTION_LEG_ACTION.BUY_TO_OPEN;
    case 'BTC':
      return OPTION_LEG_ACTION.BUY_TO_CLOSE;
    case 'STO':
      return OPTION_LEG_ACTION.SELL_TO_OPEN_COVERED;
    case 'STC':
      return OPTION_LEG_ACTION.SELL_TO_CLOSE;
    case 'B':
      return STOCK_LEG_ACTION.BUY;
    case 'S':
      return STOCK_LEG_ACTION.SELL;
    default:
      return null;
  }
}

export const OptionLeg = function(action, quantity, option) {
  this.action = action;
  this.quantity = quantity;
  this.option = option;
  this.assetClass = ASSET_CLASS.OPTION;
};

export const StockLeg = function(action, quantity, stock) {
  this.action = action;
  this.quantity = quantity;
  this.stock = stock;
  this.assetClass = ASSET_CLASS.STOCK;
};

export function isStock(leg) {
  return leg.assetClass.id === ASSET_CLASS.STOCK.id;
}

export function isOption(leg) {
  return leg.assetClass.id === ASSET_CLASS.OPTION.id;
}

export function isBuy(leg) {
  return leg.action.direction.id === ACTION_DIRECTION.BUY.id;
}

export function isSell(leg) {
  return leg.action.direction.id === ACTION_DIRECTION.SELL.id;
}
